import { Badge } from "@/components/ui";
import { domainLabel } from "@/components/test-cases/allTestCasesSearch";
import { cn } from "@/lib/utils";
import type { ReferenceReviewStatus } from "@/types";
import { REVIEW_LABEL, REVIEW_TONE } from "./referenceReview";

export function ReviewBadge({ status }: { status: ReferenceReviewStatus }) {
  return (
    <Badge size="compact" className={REVIEW_TONE[status]}>
      {REVIEW_LABEL[status]}
    </Badge>
  );
}

export function DomainChip({ domain }: { domain: string | null | undefined }) {
  return (
    <span
      className={cn(
        "rounded-full px-2 py-px text-[11.5px] whitespace-nowrap",
        domain ? "bg-accent text-accent-foreground" : "bg-muted text-muted-foreground",
      )}
    >
      {domainLabel(domain || "__none__")}
    </span>
  );
}
